<template>
  <div class="main">
    <Header></Header>
    <router-view class="main-content" />
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../header/header";
import Footer from "../footer/footer";
export default {
  name: "Main",
  components: {
    Header,
    Footer
  },
  data() {
    return {};
  }
};
</script>
<style lang="less">
@import "./main.less";
@import "../../styles/reset.css";
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue